import {
  INICIA_SERIE,
  NOVO_SERIE,
  BUSCA_SERIE_EDICAO,
  CANCELA_EDICAO,
  INICIO_SERIE_SUCESSO,
  SALVA_SERIE_SUCESSO,
  REMOVE_SERIE_SUCESSO,
  BUSCA_SERIE_EDICAO_SUCESSO,
  INIT_URL,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  ON_SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  ALTERACAO_CAMPO,
  ALTERACAO_COMBO,
  ALTERACAO_DATEPICKER,
  ALTERACAO_CHECK,
  APLICA_FILTRO,
  LISTA_SERIE,
  LISTA_SERIE_SUCESSO,
  LIMPAR_SERIE,
  GET_REGRAS_AVALIACAO_SUCCESS,
  LISTA_ESCOLAS_SERIE_SUCESSO,
  LISTA_CURSOS_POR_ESCOLA_SERIE_SUCESSO,
  APLICA_FILTRO_SERIE
} from "constants/ActionTypes";

const normalizeSerieListItem = (item) => {
  if (!item) return {};
  const id = item.id || item.Id || 0;
  const nome = item.nome || item.Nome || '';
  const codigo = item.codigo || item.Codigo || '';
  const cursoNome = item.cursoNome || item.CursoNome || item.curso?.nome || item.Curso?.Nome || '';
  const cargaHoraria = item.cargaHoraria || item.CargaHoraria || '';
  return { ...item, id, nome, codigo, cursoNome, cargaHoraria };
};

const INIT_STATE = {
  // Configuração da Grid
  colunasGrid: [
    { titulo: 'Código', propriedadeApi: 'id', alinhamento: 'left' },
    { titulo: 'Série', propriedadeApi: 'nome', alinhamento: 'left' },
    { titulo: 'Curso', propriedadeApi: 'cursoNome', alinhamento: 'left' },
    { titulo: 'Carga Horária', propriedadeApi: 'cargaHoraria', alinhamento: 'left' }
  ],

  // Propriedades Globais
  loader: false,
  alertMessage: '',
  showMessageSuccess: false,
  showMessageError: false,
  edicao: false,
  carregandoLista: true,
  listGrid: [],
  listGridComFiltro: [],
  textoFiltro: '',
  serieCarregada: null,

  // Campos mínimos do formulário de Série
  id: 0,
  codigo: '',
  nome: '',
  cargaHoraria: '',
  descricao: '',
  cursoId: null,
  diasLetivos: 0,
  idadeIdeal: null,
  idadeInicial: null,
  idadeFinal: null,
  etapaCurso: '',
  concluinte: 1,
  alertaFaixaEtaria: false,
  bloquearMatriculaFaixaEtaria: false,

  // Subentidade 1:N: Regras de Avaliação vinculadas à Série
  regrasAvaliacao: [],

  // Lista de regras de avaliação disponíveis para dropdown
  listaRegrasAvaliacaoDisponiveis: [],

  // Filtros
  nomeSerieFiltro: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INICIA_SERIE: {
      return {
        ...state,
        edicao: false,
        loader: true,
        carregandoLista: true,
      }
    }
    case NOVO_SERIE: {
      return {
        ...state,
        edicao: true,
        loader: false,
        id: 0,
        codigo: '',
        nome: '',
        cargaHoraria: '',
        descricao: '',
        cursoId: null,
        diasLetivos: 0,
        idadeIdeal: null,
        idadeInicial: null,
        idadeFinal: null,
        etapaCurso: '',
        concluinte: 1,
        alertaFaixaEtaria: false,
        bloquearMatriculaFaixaEtaria: false,
        regrasAvaliacao: [],
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case BUSCA_SERIE_EDICAO: {
      return {
        ...state,
        loader: true
      }
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        edicao: false,
      }
    }
    case INICIO_SERIE_SUCESSO: {
      const retorno = action.payload || [];
      const lista = Array.isArray(retorno) ? retorno : (retorno && (retorno.serie || retorno.Serie) ? (retorno.serie || retorno.Serie) : []);
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: lista,
        listGridComFiltro: lista,
      }
    }
    case SALVA_SERIE_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case REMOVE_SERIE_SUCESSO: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: false
      }
    }
    case LISTA_SERIE: {
      return {
        ...state,
        loader: true,
        carregandoLista: true,
      }
    }
    case APLICA_FILTRO_SERIE: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case LISTA_SERIE_SUCESSO: {
      const retorno = action.payload;
      const rawList = Array.isArray(retorno) ? retorno : (retorno && (retorno.serie || retorno.Serie) ? (retorno.serie || retorno.Serie) : []);
      const lista = rawList.map(normalizeSerieListItem);
      return {
        ...state,
        loader: false,
        carregandoLista: false,
        listGrid: lista,
        listGridComFiltro: lista,
      }
    }
    case LISTA_ESCOLAS_SERIE_SUCESSO: {
      const escolasRaw = action.payload?.escolas || action.payload || [];
      const listaEscolas = Array.isArray(escolasRaw)
        ? escolasRaw.map(e => ({ id: e.id || e.Id, title: e.nome || e.Nome }))
        : [];
      return { ...state, listaEscolas };
    }
    case LISTA_CURSOS_POR_ESCOLA_SERIE_SUCESSO: {
      const cursosRaw = action.payload?.cursos || action.payload || [];
      const listaCursos = Array.isArray(cursosRaw)
        ? cursosRaw.map(c => ({ id: c.id || c.Id, title: c.nome || c.Nome }))
        : [];
      return { ...state, listaCursos };
    }
    case LIMPAR_SERIE: {
      return {
        ...state,
        nomeSerieFiltro: '',
        textoFiltro: '',
        escolaFiltroSerie: null,
        cursoFiltroSerie: null
      }
    }
    case GET_REGRAS_AVALIACAO_SUCCESS: {
      // Armazena a lista de regras de avaliação disponíveis para uso no dropdown
      const lista = Array.isArray(action.payload) ? action.payload : [];
      return {
        ...state,
        listaRegrasAvaliacaoDisponiveis: lista
      }
    }
    case BUSCA_SERIE_EDICAO_SUCESSO: {
      var retorno = action.payload;
      var base = retorno && retorno.serie ? retorno.serie : retorno;
      return {
        ...state,
        edicao: true,
        loader: false,
        serieCarregada: base,
        id: base.id || base.Id || 0,
        codigo: base.codigo || base.Codigo || '',
        nome: base.nome || base.Nome || '',
        cargaHoraria: base.cargaHoraria || base.CargaHoraria || '',
        descricao: base.descricao || base.Descricao || '',
        cursoId: base.cursoId || base.curso_id || base.CursoId || null,
        diasLetivos: base.diasLetivos || base.DiasLetivos || base.dias_letivos || 0,
        idadeIdeal: base.idadeIdeal || base.IdadeIdeal || base.idade_ideal || null,
        idadeInicial: base.idadeInicial || base.IdadeInicial || base.idade_inicial || null,
        idadeFinal: base.idadeFinal || base.IdadeFinal || base.idade_final || null,
        etapaCurso: (base.etapaCurso !== undefined && base.etapaCurso !== null) ? base.etapaCurso
          : (base.EtapaCurso !== undefined && base.EtapaCurso !== null) ? base.EtapaCurso
            : (base.etapa_curso !== undefined && base.etapa_curso !== null) ? base.etapa_curso
              : '',
        concluinte: (base.concluinte !== undefined && base.concluinte !== null) ? base.concluinte
          : (base.Concluinte !== undefined && base.Concluinte !== null) ? base.Concluinte
            : false,
        alertaFaixaEtaria: base.alertaFaixaEtaria || base.AlertaFaixaEtaria || base.alerta_faixa_etaria || false,
        bloquearMatriculaFaixaEtaria: base.bloquearMatriculaFaixaEtaria || base.BloquearMatriculaFaixaEtaria || base.bloquear_matricula_faixa_etaria || false,
        // Normaliza possíveis convenções da subentidade
        regrasAvaliacao: Array.isArray(base.regrasAvaliacao) ? base.regrasAvaliacao
          : Array.isArray(base.RegrasAvaliacao) ? base.RegrasAvaliacao
            : Array.isArray(base.regras_avaliacao) ? base.regras_avaliacao
              : [],
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false,
        loader: false,
        carregandoLista: false,
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
        carregandoLista: false,
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_SHOW_ERROR_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageError: true,
        edicao: false,
        carregandoLista: false,
      }
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
      return {
        ...state,
        loader: false,
        alertMessage: action.payload,
        showMessageSuccess: true,
        edicao: state.edicao,
        carregandoLista: false,
      }
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false,
        carregandoLista: false,
      }
    }
    case ALTERACAO_CAMPO: {
      return {
        ...state,
        [action.payload.target.name]: action?.payload?.target?.value,
      }
    }
    case ALTERACAO_COMBO: {
      const valorBruto = action.payload.valor;
      const valorNormalizado = (valorBruto && typeof valorBruto === 'object')
        ? (valorBruto.id !== undefined ? valorBruto.id : (valorBruto.value !== undefined ? valorBruto.value : valorBruto))
        : valorBruto;
      return {
        ...state,
        [action.payload.nomeCombo]: valorNormalizado,
      }
    }
    case ALTERACAO_CHECK: {
      var retorno = action.payload;
      return {
        ...state,
        [retorno.name]: retorno.value
      }
    }
    case ALTERACAO_DATEPICKER: {
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      }
    }
    default:
      return state;
  }
}